
import firebase from './firebase';
export function test() {
    console.log("Function Working")
}
export function printIt(bu,o) {
    console.log(bu,o)
}
export function catchingError(error) {
    console.log("Error detected", error)
}

//export async function fetchAllArticles() {
 // try {
  //  const articlesRef = firebase.firestore().collection("Articles");
  //  const querySnapshot = await articlesRef.where("uid", "==", "Zo7drLqKW4ZZAmw7RKRDTzWT1Pj1").get();

  //  const articles = [];
  //  querySnapshot.forEach((doc) => {
  //    articles.push(doc.data());
  //  });

  //  return articles; // Will contain only articles with matching UID
  //} catch (error) {
  //  console.error("Error fetching article by UID:", error);
  //  throw error;
 // }
  
//}
export async function fetchAllArticles() {
  try {
    const articlesRef = firebase.firestore().collection("Articles");
    const querySnapshot = await articlesRef
      .where("uid", "==", "Zo7drLqKW4ZZAmw7RKRDTzWT1Pj1")
      .get();

    const articles = [];
    querySnapshot.forEach((doc) => {
      articles.push({ id: doc.id, ...doc.data() });
    });

    // Sort articles based on publishedDate
    articles.sort((a, b) => {
      if (a.publishedDate && b.publishedDate) {
        return b.publishedDate.toMillis() - a.publishedDate.toMillis(); // Newest first
      } else if (a.publishedDate) {
        return -1;
      } else if (b.publishedDate) {
        return 1;
      } else {
        return 0;
      }
    });

    return articles; 
  } catch (error) {
    console.error("Error fetching article by UID:", error);
    throw error;
  }
}
export async function fetchEveryArticle() {
  try {
    console.log("Trying in functions");

    const articlesRef = firebase.firestore().collection("Articles");
    const articles = [];

    const snapshot = await articlesRef.get();  // Get all the documents in the collection
    snapshot.forEach((doc) => {  // Loop through each document in the snapshot
      console.log("doc.data()", doc.data());
      articles.push(doc.data());  // Push each document's data into the articles array
    });

    console.log("articles", articles.length);  // Log the array with all articles
    return articles;
  } catch (error) {
    console.error("Error fetching articles:", error);
    throw error;
  }
}


export const fetchArticle = async (uid, setArticle) => {
  try {
    const articleRef = firebase.firestore().collection("Articles").doc(uid);
    const doc = await articleRef.get();

    if (doc.exists) {
      const articleData = doc.data();
      console.log("Fetched article data:", articleData);

      // Check if data is in expected format, and sanitize if needed
      if (articleData && typeof articleData.title === 'string') {
        setArticle(articleData);  // Set the article data in the state
      } else {
        console.log("Article data is in an unexpected format:", articleData);
      }
    } else {
      console.log("No such article!");
    }
  } catch (error) {
    console.error("Error fetching article:", error);
  }
};

export async function fetchAllBusinesses() {
  try {
    const businessesRef = firebase.firestore().collection("Businesses");
    const querySnapshot = await businessesRef.get();
    const businesses = [];
    querySnapshot.forEach((doc) => {
      businesses.push({ id: doc.id, ...doc.data() });
    });
    // Sort businesses alphabetically by company name
    businesses.sort((a, b) => {
      const nameA = a.company?.toLowerCase() || '';
      const nameB = b.company?.toLowerCase() || '';
      return nameA.localeCompare(nameB);
    });
    return businesses;
  } catch (error) {
    console.error("Error fetching businesses:", error);
    throw error;
  }
}

